<template>
  <div @mouseenter="mouseenter" @mouseleave="mouseleave">
    <slot></slot>
  </div>
</template>
<script>
import Swiper from 'swiper/bundle'

export default {
  data () {
    return {
      swiper: null,
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.swiper = new Swiper(this.$el, {
        slidesPerGroup: 1,
        slidesPerView: 1,
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        hashNavigation: false,
        spaceBetween: 10,
        speed: 750,
        loop: false,
        autoplay: {
          delay: 4000
        },
        breakpoints: {
          480: {
            slidesPerGroup: 1,
            slidesPerView: 1
          },
          768: {
            slidesPerGroup: 2,
            slidesPerView: 2
          },
          1000: {
            slidesPerGroup: 2,
            slidesPerView: 2
          },
          1200: {
            slidesPerGroup: 2,
            slidesPerView: 2
          }
        }
      })
    })
  },
  methods: {
    mouseenter () {
      if (this.swiper) {
        this.swiper.autoplay.stop()
      }
    },
    mouseleave () {
      if (this.swiper) {
        this.swiper.autoplay.start()
      }
    }
  }
}
</script>